export const environment: any = {
  production: true,
  apiUrl: 'https://api.admin.merchandising-bb.com.br',
  useToken: true
};
